import { HttpParams, HttpHeaders, HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { FormControl, Validators, FormGroup, ValidatorFn, AbstractControl } from '@angular/forms';
import { OfbizForm, OfbizFormField, OfbizHiddenField, OfbizDisplayField, OfbizTexboxField, OfbizTexboxQBEField, OfbizDateTimeField, OfbizDropdownField, OfbizTextAreaField, RemoteFormData, ColumnFieldTitle, FieldSet, OfbizPasswordField, OfbizFileField } from './ofbiz-form-model';
import { of as observableOf, Subject, Observable, of, throwError } from 'rxjs';
import { tap, map, catchError, debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { HttpParamsOptions, OfbizLookupField, lookUpRequests } from './ofbiz-form-model';

@Injectable({
  providedIn: 'root'
})
export class OfbizFormsService {
  strongPasswordRegx: RegExp = /^(?=[^A-Z]*[A-Z])(?=[^a-z]*[a-z])(?=\D*\d).{8,}$/;
  /* private lookUpQuerySubject = new Subject<string>();
  lookUpEndPoint:string;
  lookUpEntity:string;
  lookUpSearchFields:string;
  lookUpFormName:string; */

  /*   readonly result = this.lookUpQuerySubject.pipe(
      liveSearch(query => this.doLookUp(query,this.lookUpSearchFields,this.lookUpEntity,this.lookUpFormName))
    ) */

  constructor(@Inject('baseUrl') private baseUrl: string,
    private http: HttpClient) { }

  getBaseUrl() {
    return this.baseUrl;
  }

  getForm(optionsObject: any): Observable<any> {
    // console.log(optionsObject);
    const url = this.baseUrl + 'getForm'
    const httpParams: HttpParamsOptions = { fromObject: optionsObject } as HttpParamsOptions;
    // console.log(httpParams);
    const options = { params: new HttpParams(httpParams), withCredentials: true };
    return this.http.get<OfbizForm>(url, options)
      .pipe(
        tap(() => console.log('HTTP request executed')),
        map(resp => resp)
      );
  }

  toFormGroup(formFields: OfbizFormField<any>[]) {
    const group: any = {};

    formFields.forEach(formField => {
      const controlType = formField.controlType;
      console.log(controlType)
      const validatorFunctions: ValidatorFn[] = [];
      if (formField.required) {
        validatorFunctions.push(Validators.required);
      }
      switch (controlType) {
        case "password":
          validatorFunctions.push(Validators.minLength(8));
          validatorFunctions.push(Validators.pattern(this.strongPasswordRegx))
          group[formField.name] = new FormControl(formField.value || '', validatorFunctions)
          console.log(group[formField.name].hasValidator(Validators.required))
          /* group[formField.name] = formField.required ? new FormControl(formField.value || '',[Validators.required,Validators.minLength(8)])
                                :  new FormControl(formField.value || '',Validators.minLength(8)); */
          break;
        case "email":
          group[formField.name] = formField.required ? new FormControl(formField.value || '', [Validators.required, Validators.email])
            : new FormControl(formField.value || '');
          break;

        default:
          group[formField.name] = formField.required ? new FormControl(formField.value || '', Validators.required)
            : new FormControl(formField.value || '');
          break;
      }
      /* group[formField.name] = formField.required ? new FormControl(formField.value || '',Validators.required)
                            :  new FormControl(formField.value || ''); */
    });
    console.log({ Group: group });
    return new FormGroup(group);
  }

  getFormFields(rawFields: any[]): Observable<OfbizFormField<any>[]> {
    const fields: OfbizFormField<any>[] = [];
    rawFields.forEach((field, i) => {
      let currentValue = null;
      if (field.order) {
        i = field.order;
      }
      if (field.value) {
        currentValue = field.value;
      } else {
        currentValue = field.currentValue;
      }
      switch (field.type) {
        case "hidden":
        case "HIDDEN":
          // console.log("This is a display");
          const hiddenField = new OfbizHiddenField({
            key: field.id,
            label: field.title,
            value: field.value,
            name: field.name,
            order: i,
            required: field.required,
          });
          fields.push(hiddenField);
          break;
        case "display":
        case "DISPLAY":
          // console.log("This is a display");
          const displayfield = new OfbizDisplayField({
            key: field.id,
            label: field.title,
            value: field.value,
            name: field.name,
            order: i,
            required: field.required,
          });
          fields.push(displayfield);
          break;
        case "text":
        case "TEXT":
          // console.log("This is a input");
          const textBoxField = new OfbizTexboxField({
            key: field.id,
            label: field.title,
            value: field.value,
            name: field.name,
            order: i,
            required: field.required,
          });
          fields.push(textBoxField);
          break;
        case "textqbe":
        case "TEXTQBE":
          console.log(field);
          const textqbe = new OfbizTexboxQBEField({
            key: field.id,
            label: field.title,
            value: field.value,
            name: field.name,
            order: i,
            required: field.required,
            endpoint: field.endpoint,
            lookupOptions: field.lookupOptions,
          });
          console.log(textqbe);
          fields.push(textqbe);
          break;
        case 'datetime':
        case "DATE_TIME":
          // console.log("This is a input");
          const datetimeField = new OfbizDateTimeField({
            key: field.id,
            label: field.title,
            value: field.value,
            name: field.name,
            order: i,
            required: field.required,
          });
          fields.push(datetimeField);
          break;
        case "dropdown":
        case "DROP_DOWN":
          // console.log("This is a dropdown");
          const dropDownField = new OfbizDropdownField({
            key: field.id,
            label: field.title,
            value: field.value,
            name: field.name,
            order: i,
            required: field.required,
            selectOptions: this.convertOptions(field.allOptionValues ? field.allOptionValues : field.options),
          });
          fields.push(dropDownField);
          break;
        case "lookup":
        case "LOOKUP":
          const lookupField = new OfbizLookupField({
            key: field.id,
            label: field.title,
            value: field.value,
            name: field.name,
            order: i,
            required: field.required,
            endpoint: field.endpoint,
            lookupOptions: field.lookupOptions,
          });
          // console.log(lookupField);
          fields.push(lookupField);
          break;
        case "textarea":
        case "TEXTAREA":
          const textAreaField = new OfbizTextAreaField({
            key: field.id,
            label: field.title,
            value: field.value,
            name: field.name,
            order: i,
            required: field.required,
            useEditor: field.useEditor
          });
          fields.push(textAreaField);
          break;
        case "password":
        case "PASSWORD":
          // console.log("This is a input");
          const passwordField = new OfbizPasswordField({
            key: field.id,
            label: field.title,
            value: field.value,
            name: field.name,
            order: i,
            required: field.required,
          });
          fields.push(passwordField);
          break;
        case "file":
        case "FILE":
          // console.log("This is a input");
          const fileField = new OfbizFileField({
            key: field.id,
            label: field.title,
            value: field.value,
            name: field.name,
            order: i,
            required: field.required,
          });
          fields.push(fileField);
          break;
      }
    });
    fields.sort((a, b) => a.order - b.order);
    return observableOf(fields);
  }
  convertOptions(allOptionValues: any[]) {
    // console.log("converting dropdownOptions");
    // console.log(allOptionValues);
    const options = [];
    allOptionValues.forEach(allOptionValue => {
      const entry = {};
      entry['value'] = allOptionValue.key;
      entry['key'] = allOptionValue.description;
      options.push(entry);
    });
    // console.log(options);
    return options;
  }

  submitForm(form: any, target: string): Observable<any> {
    console.log(target);
    const url: string = this.baseUrl + target;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    }
    return this.http.post(url, form, httpOptions)
      .pipe(
        map(resp => resp)
      );
  }

  /* lookUpInitial(query: string,fieldName:string):Observable<any>{
    let empty = "No records Found";
    let lookUpRequest = this.getLookupRequestDetail(fieldName);
    if(lookUpRequest != null){
      return this.doLookUp(query,lookUpRequest.endPoint,lookUpRequest.entityName,this.lookUpFormName)
      .pipe(
        map(resp => resp)
      );
    }else{
      return observableOf(empty);
    }


  } */
  /**
   *
   * @param query The term to be used in the search
   * @param fieldName Name of the form field for which the lookup is done
   * @param entityName Name of the Entity to be searched
   * @param searchFields String Fields that will be searched on the backend
   * @param fieldFormName Name of the remote form which will be used to return results
   */
  /* lookUp(query: string,fieldName:string,entityName:string,searchFields:string,fieldFormName:string):void {
    console.log({TrackLookup:{query:query,fieldName:fieldName,entityName:entityName,searchFields:searchFields}})
    if(searchFields != null && entityName != null){
      console.log({TrackLookupField:"No endPoint & No entityName",field:fieldName})
      this.lookUpSearch(query,searchFields,entityName,fieldFormName);
    }else{
      console.log({TrackLookupField:"GetLookupRequestDetail"})
      let lookUpRequest = this.getLookupRequestDetail(fieldName);
      console.log({TrackLookupField:{lookUpRequest:lookUpRequest}});
      if(lookUpRequest != null){
        this.lookUpEndPoint = lookUpRequest.endPoint;
        this.lookUpEntity = lookUpRequest.entityName;
        this.lookUpQuerySubject.next(query);
      }
    }

  } */

  /* lookUpSearch(query:string,searchFields:string,entityName:string,fieldFormName:string){
    console.log({TrackLookupField:{function:"lookUpSearch",detail:{query:query,searchFields:searchFields,entityName:entityName}}})
    this.lookUpSearchFields = searchFields;
    this.lookUpEntity = entityName;
    this.lookUpFormName = fieldFormName;
    this.lookUpQuerySubject.next(query);
  } */

  /* resetLookUp():void{
    console.log("Resetting ....")
    this.lookUpQuerySubject.next("");
  } */

  /*  doLookUp(query: string,searchFields:string,entityName:string,fieldFormName:string){
     console.log({TracklookupField:"yeah"});
     let endPoint = "widgets/form/value/"+fieldFormName;
     let url = this.baseUrl+endPoint+"?";
     let queryType = fieldFormName === "LookupLocale" ? "localeName" : "term";
     return this.http.get<any>(`${url}location=component://kwikstore/widget/KwikstoreForms.xml&${queryType}=${query}&entityName=${entityName}&searchFields=${searchFields}`).pipe(
       map((response:any) => {
         let statusCode = response.statusCode;
         switch (statusCode) {
           case 200:
             if(response.successMessage == "OK"){
               let data = response.data;
               const formData = data["formData"];
               const rows:any[] = formData.rows;
               let transformedItems:any[] = [];
               rows.forEach((row:any[]) => {
                 let transItem = {};
                 let idItem = row[0];
                 transItem["id"] = (Object.values(idItem))[0];
                 let descItem = row[1];
                 transItem["description"] = (Object.values(descItem))[0];
                 transformedItems.push(transItem);
               });
               console.log({TrackItems:transformedItems});
               return transformedItems;
             }
             break;
           case 404:
             break;
           case 500:
             break;
           default:
             break;
         }
       }),
       catchError(err => of([]))
     );
   } */

  fixTitle(name: string): any {
    let out = name.replace(/^\s*/, "");  // strip leading spaces
    out = out.replace(/^[a-z]|[^\s][A-Z]/g, function (name, offset) {
      if (offset == 0) {
        return (name.toUpperCase());
      } else {
        return (name.substr(0, 1) + " " + name.substr(1).toUpperCase());
      }
    });
    return (out);
  }

  getYesNoOptions(): any[] {
    return [
      { "key": "Y", "description": "Y" },
      { "key": "N", "description": "N" }
    ];
  }

  getList(remoteFormData: RemoteFormData): Observable<any> {
    // console.log("formData in",formData);
    /* const httpOptions = {
      headers:new HttpHeaders({
        'Content-Type':'application/json'
      })
    } */
    console.log({ GetListFormData: remoteFormData.formData });
    console.log({ parameters: remoteFormData.parameters });
    let url = "";
    const listType = remoteFormData.formData.listType;
    const parameters = remoteFormData.parameters;
    const formData = remoteFormData.formData;
    let params = new HttpParams()
      .set('location', remoteFormData.formData.formLocation);
    // .set('noConditionFind', "Y");
    if (parameters != null) {
      console.log("parameters is not null");
      const keys = Object.keys(parameters);
      keys.forEach((key) => {
        params = params.set(key, parameters[key]);
      });
    } else {
      console.log("parameters is null");
    }
    console.log({ params: params, listType: listType });
    switch (listType) {
      case "grid":
        url = this.baseUrl + "widgets/grid/value/" + formData.formName + "?";
        break;
      case "list":
        url = this.baseUrl + "widgets/list/value/" + formData.formName + "?";
        break;
      case "multi":
        url = this.baseUrl + "widgets/multi/value/" + formData.formName + "?";
        break;
      default:
        url = this.baseUrl + "widgets/form/value/" + formData.formName + "?";
        break;
    }
    /* if(listType != null && listType == "grid"){
      url = this.baseUrl+"widgets/grid/value/"+formData.formName+"?";
    }else{
      url = this.baseUrl+"widgets/list/value/"+formData.formName+"?";
    } */
    return this.http.get<any>(url, { params })
      .pipe(
        map(resp => resp)
      )
  }

  getOne(formData): Observable<any> {
    const url = this.baseUrl + "getOne?";
    return this.http.post<any>(url, formData)
      .pipe(
        map(resp => resp)
      )
  }

  /* getLookupRequestDetail(fieldName:string){
    let lookupRequestDetail = null;
    lookupRequestDetail = lookUpRequests.find(lookUpRequest => lookUpRequest.fieldName === fieldName);
    return lookupRequestDetail;
  } */

  getView(formData): Observable<any> {
    const url = this.baseUrl + "getView?";
    return this.http.post<any>(url, formData)
      .pipe(
        map(resp => resp)
      )
  }
  /**
   *
   * @param formData Object consisting of (1) the formName and (2) the formLocation
   * @param parameters Key/Value object send to the backend which will be used to get the value
   * @param endpoint Not used and should be removed
   * @returns
   */
  getValue(formData: any, parameters, endpoint: string): Observable<any> {
    console.log({ formData: formData, endpoint: endpoint });
    console.log({ parameters: parameters });
    let params = new HttpParams()
      .set('location', formData.formLocation);
    // .set('noConditionFind', "Y");
    if (parameters != null) {
      console.log("parameters is not null");
      const keys = Object.keys(parameters);
      keys.forEach((key) => {
        params = params.set(key, parameters[key]);
      });
    } else {
      console.log("parameters is null");
    }
    console.log({ params: params });
    const url = this.baseUrl + "widgets/form/value/" + formData.formName + "?";
    return this.http.get<any>(url, { params })
      .pipe(
        map(resp => resp)
      )
  }

  view(formData): Observable<any> {
    const url = this.baseUrl + "view?";
    return this.http.post<any>(url, formData)
      .pipe(
        map(resp => resp)
      )
  }
  /**
   *
   * @param formData FormData Object containing field names and values
   * @param appContext Backend controller where event is registered
   * @param target Targeted event name as defined in the request map in the relevant controller
   * @param isMultiPart Whether this is a single or multipart body
   * @returns
   */
  postFormData(formData: FormData, appContext: string, target: string, isMultiPart: boolean): Observable<any> {
    console.log({ isMultiPart: isMultiPart });
    let url = this.baseUrl + "event/";
    let httpOptions;
    let headers = new HttpHeaders();
    if (isMultiPart) {
      console.log("isMultiPart is true");
      url = url + "multipart/";

      headers = headers.append('enctype', 'multipart/form-data');
      headers = headers.append('Content-Type', 'multipart/form-data');
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'multipart/form-data'
        })
      }
    }
    if (appContext != null) {
      url = url + appContext + "/" + target
    } else {
      url = url + target;
    }
    // console.log({TrackUrl:url});
    /* const options = {
      headers: new HttpHeaders({
        "Content-Type": "x-www-form-urlencoded",
        'Content-Type':'multipart/form-data',
        'Content-Type': 'undefined',
      })
  } */
    // const headers = new HttpHeaders({ "Content-Type": "x-www-form-urlencoded" });
    // const options = new RequestOptions({ headers });
    if (isMultiPart) {
      return this.http.post<any>(url, formData)
        .pipe(
          map(resp => resp)
        )
    } else {
      return this.http.post<any>(url, formData)
        .pipe(
          map(resp => resp)
        )
    }

  }
  /**
   *
   * @param entity The entity to lookup
   * @param lookupField the field to be queried
   * @param term the term used in the query
   * @returns
   */
  getLookUp(entity, lookupField, term): Observable<any> {
    const url = this.baseUrl + "lookup/" + entity + "/" + lookupField + "/" + term;
    return this.http.get<any>(url)
      .pipe(catchError(this.errorHandler),
        map(resp => resp)
      )
  }
  private errorHandler(error: HttpErrorResponse) {
    console.log(error);
    let errorMessage = "";
    if (error.status === 0) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      errorMessage = error.error.errorMessage;
      console.error(
        `Backend returned code ${error.status}, body was: `, error.error.statusCode);
    }
    // Return an observable with a user-facing error message.
    return throwError(error.error);
  }
  /**
   *
   * @param formData key/value pairs
   * @param endpoint backend endpoint used by rest
   * @returns
   */
  postFormDataTest(formData: FormData, endpoint: string): Observable<any> {
    // console.log({isMultiPart:isMultiPart});
    // this.baseUrl = "https://localhost:8334/rest/"
    const url = this.baseUrl + endpoint;

    /* if(isMultiPart){
      console.log("isMultiPart is true");
      url = url+"multipart/";
    }
    if(appContext != null){
      url = url+appContext+"/"+target
    }else{
      url = url+target;
    } */
    console.log({ TrackUrl: url });
    /* const options = {
      headers: new HttpHeaders({
        'enctype': 'multipart/form-data'
      })
    } */
    // console.log({TrackOptions:options});
    // const headers = new HttpHeaders({ "Content-Type": "x-www-form-urlencoded" });
    // const options = new RequestOptions({ headers });
    return this.http.post<any>(url, formData)
      .pipe(
        map(resp => resp)
      )
  }
  getWithPathParams(endpoint: string): Observable<any> {
    const url = this.baseUrl + endpoint;
    return this.http.get<any>(url)
      .pipe(
        map(resp => resp)
      )
  }
  /**
     * Function to generate fields given the name of the form (formName)
     * and FORMS (Array of forms)
     * @param formName
     * @param FORMS
     * @returns fields
     */
  getFields(formName: string, FORMS): any[] {
    let fields: any[];
    let columnFieldTitles: ColumnFieldTitle[];
    const localForm = FORMS.find(form => form.name == formName || form.formName == formName);
    if (localForm) {
      fields = localForm.fields;
      columnFieldTitles = columnFieldTitles = localForm.columns;
      if (columnFieldTitles != undefined && columnFieldTitles.length > 0) {
        // console.log("Found columnFieldTitles");
        fields.forEach(field => {
          const columnField = columnFieldTitles.find(element => element.name == field.name);
          if (columnField) {
            // console.log({FoundColumnField:{field:field.name,columnFieldTitle:columnField}})
            field.title = columnField.title;
          }
        })

      }
    }
    return fields;
  }
  /**
   *
   * @param formName The name of the form (used to find the form in an array of forms)
   * @param FORMS Array of forms including the form to be selected
   * @returns Array containing fieldSets
   */
  getFieldSets(formName: string, FORMS): FieldSet[] {
    let fieldSets = [];
    const localForm = FORMS.find(form => form.name == formName || form.formName == formName);
    fieldSets = localForm.fieldSets;
    return fieldSets;
  }
  getTarget(formName: string, FORMS): string {
    let target = "";
    const localForm = FORMS.find(form => form.name == formName || form.formName == formName);
    target = localForm.target;
    return target;
  }
  getAltTarget(formName: string, FORMS): any[] {
    let altTargets = [];
    const localForm = FORMS.find(form => form.name == formName || form.formName == formName);
    altTargets = localForm.altTarget;
    return altTargets;
  }
  getLayout(formName: string, FORMS): string {
    let layout = "";
    const localForm = FORMS.find(form => form.name == formName || form.formName == formName);
    layout = localForm.layout ? localForm.layout : "MultiColumn";
    return layout;
  }
  /**
   *
   * @param formName
   * @param FORMS
   * @returns targets object consisting of createTarget and EditTarget
   */
  getTargets(formName: string, FORMS): any {
    let targets = {}
    const form = FORMS.find(form => form.name == formName || form.formName == formName);
    targets = form.targets;
    return targets
  }
  getValidators(formField: OfbizFormField<any>): ValidatorFn[] {
    const controlType = formField.controlType;
    const validatorFunctions: ValidatorFn[] = [];
    if (formField.required || formField["className"] == "required") {
      validatorFunctions.push(Validators.required);
    }
    switch (controlType) {
      case "password":
        validatorFunctions.push(Validators.minLength(8));
        validatorFunctions.push(Validators.pattern(this.strongPasswordRegx))
        break;

      default:
        break;
    }
    return validatorFunctions
  }
  createCamelCase(inString: string): string {
    let outString = "";
    const s = inString && inString
      .match(
        /[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g
      )
      .map(x => x.slice(0, 1).toUpperCase() + x.slice(1).toLowerCase())
      .join('');
    outString = s.slice(0, 1).toLowerCase() + s.slice(1);
    return outString;
  }



  passwordMatch(password: string, confirmPassword: string): ValidatorFn {
    return (formGroup: AbstractControl): { [key: string]: any } | null => {
      const passwordControl = formGroup.get(password);
      const confirmPasswordControl = formGroup.get(confirmPassword);

      if (!passwordControl || !confirmPasswordControl) {
        return null;
      }

      if (
        confirmPasswordControl.errors &&
        !confirmPasswordControl.errors.passwordMismatch
      ) {
        return null;
      }

      if (passwordControl.value !== confirmPasswordControl.value) {
        confirmPasswordControl.setErrors({ passwordMismatch: true });
        return { passwordMismatch: true };
      } else {
        confirmPasswordControl.setErrors(null);
        return null;
      }
    };
  }
  /**
   * Get http client using path params to retrieve website configuration
   * @param endpoint : The endpoint on the backend
   */
  doGetWebSite(endpoint: string): Observable<any> {
    const url = this.baseUrl + endpoint;
    return this.http.get<any>(url)
      .pipe(
        map(resp => resp)
      )
  }

  handleError(error: HttpErrorResponse) {
    console.log(error);
  }
}

export function handleClick(target: HTMLElement) {

  let liElement: HTMLElement | null = target;

  while (liElement && !(liElement.tagName === "NB-OPTION")) {

    liElement = liElement.parentElement;

  }

  // console.log( "FOUND .bar !!" );
  return liElement;

}

export function flattenObj(obj: any): any {
  // The object which contains the
  // final result
  const result = {};

  // loop through the object "ob"
  for (const i in obj) {

    // We check the type of the i using
    // typeof() function and recursively
    // call the function again
    if ((typeof obj[i]) === 'object' && !Array.isArray(obj[i])) {
      const temp = flattenObj(obj[i]);
      for (const j in temp) {
        if (temp.hasOwnProperty(j)) {
          // Store temp in result
          result[i + '.' + j] = temp[j];
        }
      }
    } else {
      result[i] = obj[i];
    }
  }
  return result;
}

/* export function liveSearch<T,R>(
  dataCb: (query: T) => Observable<R>,
  delay = 250
){
  return (source$: Observable<T>) => source$.pipe(
    debounceTime(delay),
    distinctUntilChanged(),
    switchMap(dataCb)
  )
} */
